import React, { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "sonner";
import { CustomModal } from "components/modals/ModalBox";
import { addArticleApi, updateArticleApi } from "services/article";
import { addSubscriptionApi, planDetailApi, updateSubscriptionApi } from "services/subscription";
import { Select } from "common/InputForm";
import JoditEditor from "jodit-react";

const ManageActivity = ({ _id, type, onClose, isOpen, getListHandler }) => {
    const editor = useRef(null);
    const isEditable = useMemo(() => type === "EDIT", [type]);
    const [formFields, setFormFields] = useState({
        name: "",
        price: "",
        currency: "USD",
        interval: "MONTHLY",
        duration: "1",
        description: "",
        productIdAndroid: "",
        productIdIos: ""
    });

    const fetchData = async () => {
        try {
            const { data } = await planDetailApi({ _id });
            if (data?.success) {
                const detail = data?.data;
                setFormFields(prev => ({
                    ...prev,
                    name: detail?.name,
                    price: detail?.price,
                    currency: detail?.currency,
                    interval: detail?.interval,
                    duration: detail?.duration,
                    description: detail?.description,
                    productIdAndroid: detail?.productIdAndroid,
                    productIdIos: detail?.productIdIos
                }));
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (isEditable) {
            fetchData();
        }

        return () => {
            setFormFields({
                name: "",
                price: "",
                currency: "USD",
                interval: "MONTHLY",
                duration: "1",
                description: "",
                productIdAndroid: "",
                productIdIos: "",
            });
        }
    }, [isOpen]);

    // onChangeHandler
    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "number") {
            const numericValue = value.replace(/\D/g, "");
            setFormFields({ ...formFields, number: numericValue });
        } else {
            setFormFields({ ...formFields, [name]: value });
        }
    };

    // Error Handler
    const errorHandler = () => {
        let isValid = true;

        if (!formFields?.name) {
            isValid = false;
            toast.error("Please Enter Name");
            return;
        }

        if (!formFields?.price) {
            isValid = false;
            toast.error("Please Enter Price");
            return;
        }

        if (!formFields?.currency) {
            isValid = false;
            toast.error("Please Select Currency");
            return;
        }

        if (!formFields?.interval) {
            isValid = false;
            toast.error("Please Select Interval");
            return;
        }

        if (!formFields?.duration) {
            isValid = false;
            toast.error("Please Select Duration");
            return;
        }

        if (!formFields?.productIdAndroid) {
            isValid = false;
            toast.error("Please Select Product Id");
            return;
        }

        if (!formFields?.productIdIos) {
            isValid = false;
            toast.error("Please Select Product Id");
            return;
        }


        return isValid;
    };

    const createRequest = async (status) => {
        if (errorHandler()) {
            try {
                const formData = new FormData();
                const payload = {
                    ...formFields
                }

                delete payload?.uploadedImage;

                for (const key in payload) {
                    if (key === "teething" || key === "sleeping" || key === "ageGroup") {
                        formData.append(key, JSON.stringify(payload[key]));
                    } else {
                        formData.append(key, payload[key]);
                    }
                }

                const { data } = await addSubscriptionApi(formData);
                if (data?.success) {
                    toast.success(data?.message);
                    onClose();
                    getListHandler();
                } else {
                    toast.error(data?.message);
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    const updateRequest = async (status) => {
        if (errorHandler()) {
            try {
                const formData = new FormData();
                const payload = {
                    ...formFields
                }

                for (const key in payload) {
                    if (key === "teething" || key === "sleeping" || key === "ageGroup") {
                        formData.append(key, JSON.stringify(payload[key]));
                    } else {
                        formData.append(key, payload[key]);
                    }
                }

                formData.append("_id", _id);
                const { data } = await updateSubscriptionApi(formData);
                if (data?.success) {
                    toast.success(data?.message);
                    onClose();
                    getListHandler();
                } else {
                    toast.error(data?.message);
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    // onSubmitHandler
    const onSubmitHandler = async (e, status) => {
        e.preventDefault();

        if (type === "CREATE") {
            createRequest(status);
        } else {
            updateRequest(status);
        }
    };

    return (
        <CustomModal className={"lg"} show={isOpen} handleClose={onClose}>
            <div className="personal_details_parents" style={{ padding: 0 }}>
                <div className="personal_form_wrap">
                    <h4>{isEditable ? "Update" : "Create"} Subscription </h4>

                    <div>
                        <button
                            className="button"
                            onClick={(e) => onSubmitHandler(e, "DRAFT")}
                        >
                            {isEditable ? "Update" : "Create"}
                        </button>
                    </div>

                </div>

                <form>
                    <div className="form_field_wrap choose_file">
                        <div className="form_field">
                            <label htmlFor="fname" className="label">
                                Name *
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="input"
                                onChange={onChangeHandler}
                                value={formFields?.name}
                            />
                        </div>

                        <div className="form_field">
                            <label htmlFor="password" className="label">
                                Price *
                            </label>
                            <textarea
                                name="price"
                                className="input"
                                onChange={onChangeHandler}
                                value={formFields?.price}
                            />
                        </div>
                    </div>

                    <div className="form_field_wrap">
                        <div className="form_field">
                            <label htmlFor="phn_number" className="label">
                                Currency *
                            </label>
                            <Select
                                name="currency"
                                value={formFields?.currency}
                                onChange={onChangeHandler}
                            >
                                <option value="USD">USD</option>
                            </Select>
                        </div>
                        <div className="form_field">
                            <label htmlFor="phn_number" className="label">
                                Interval *
                            </label>
                            <Select
                                name="interval"
                                value={formFields?.interval}
                                onChange={onChangeHandler}
                            >
                                <option value="MONTHLY">Month</option>
                                <option value="QUARTERLY">Quarter</option>
                                <option value="YEARLY">Year</option>
                            </Select>
                        </div>
                    </div>

                    <div className="form_field_wrap">
                        {/* <div className="form_field">
                            <label htmlFor="phn_number" className="label">
                                Duration *
                            </label>
                            <Select
                                name="duration"
                                value={formFields?.duration}
                                onChange={onChangeHandler}
                            >
                                <option value="1">1</option>
                                <option value="3">3</option>
                                <option value="6">6</option>
                                <option value="12">12</option>
                            </Select>
                        </div> */}

                        <div className="form_field">
                            <label htmlFor="password" className="label">
                                Product Id Android *
                            </label>
                            <textarea
                                name="productIdAndroid"
                                className="input"
                                onChange={onChangeHandler}
                                value={formFields?.productIdAndroid}
                            />
                        </div>

                        <div className="form_field">
                            <label htmlFor="password" className="label">
                                Product Id IOS *
                            </label>
                            <textarea
                                name="productIdIos"
                                className="input"
                                onChange={onChangeHandler}
                                value={formFields?.productIdIos}
                            />
                        </div>

                    </div>

                    <div className="form_field_wrap">
                        <div className="form_field">
                            <label htmlFor="phn_number" className="label">
                                Description *
                            </label>
                            <JoditEditor
                                ref={editor}
                                value={formFields.description}
                                tabIndex={1}
                                onBlur={(newContent) => {
                                    console.log({ newContent });
                                    setFormFields(prev => ({ ...prev, description: newContent }))
                                }}
                                config={{
                                    readonly: false,
                                    height: 300,
                                    placeholder: "Edit content here...",
                                    buttons: [
                                        'bold', 'italic', 'underline', '|',
                                        'ul', 'ol', '|',
                                        'outdent', 'indent', '|',
                                        'align', '|',
                                        'undo', 'redo', '|',
                                        'hr', 'eraser', 'copyformat', '|',
                                        'fullsize', 'preview'
                                    ]
                                    // buttons: ["ul"], // Only show the bullet points button
                                    // toolbarAdaptive: false,
                                    // toolbarSticky: false,
                                    // showXPathInStatusbar: false,
                                    // showCharsCounter: false,
                                    // showWordsCounter: false,
                                    // showPlaceholder: false,
                                    // spellcheck: false,
                                }}
                            />
                        </div>
                    </div>

                </form>

                <div className="form_border_bottom"></div>
            </div>
        </CustomModal>
    );
};

export default ManageActivity;
